import { Button, Col, Input, Label, Row, TabPane } from 'reactstrap';
import './styles.css';
import { useHistory } from 'react-router-dom';
import { FiFileText } from 'react-icons/fi';
import { IoIosCloudDone, IoIosCloudUpload } from 'react-icons/io';
import { useEffect, useState } from 'react';
import { RiArrowDropLeftLine, RiArrowDropRightLine } from 'react-icons/ri';
import { toastError } from '@src/utility/Toast';
import { useAuthOnboarding } from '@src/utility/hooks/useAuthOnboarding';
import { useLoadingGlobal } from '@src/utility/hooks/useLoadingGlobal';
import apiOnboarding from '@src/services/api-onboarding';
import api from '@src/services/api';
import { env } from 'face-api.js';

interface Finances {
  monthlyInvoicing: string;
  shareCapital?: string;
  patrimony?: string;
}

interface OtherInfo {
  marital?: string;
  education?: string;
  rg?: string;
  rgIssuer?: string;
  rgIssuedDate?: string;
  softwareDescriptor?: string;
}

interface OIdata {
  idOperator: string;
  finances: Finances;
  otherInfo?: OtherInfo;
  document: string;
}
interface SendProofProps {
  handleChangeTabe: (tab: string) => void;
  request?: Record<string, unknown>;
  otherInfoData: OIdata | null;
}

const SendProof: React.FC<SendProofProps> = ({
  handleChangeTabe,
  request,
  otherInfoData,
}) => {
  const [data, setData] = useState<any>(null);
  const { verifyLogin } = useAuthOnboarding();
  const { showLoader, hideLoader } = useLoadingGlobal();
  const [cardCnpj, setCardCnpj] = useState<FileList | null>(null);
  const [billingDeclaration, setBillingDeclaration] = useState<FileList | null>(
    null
  );
  const [socialContract, setSocialContract] = useState<FileList | null>(null);
  const [proofOfAddress, setProofOfAddress] = useState<FileList | null>(null);
  const [proofOfAccount, setProofOfAccount] = useState<FileList | null>(null);

  const [activeButton, setActiveButton] = useState(false);
  const history = useHistory();

  const isInvpay = process?.env.REACT_APP_SYSTEM_ORIGIN === 'INVPAY';

  const handleDocuments = async () => {
    try {
      await verifyLogin();
      const formData = new FormData();

      if (request) {
        showLoader();

        formData.append(
          'systemOrigin',
          `${process?.env.REACT_APP_SYSTEM_ORIGIN}`
        );

        formData.append('idOperator', `${request.idOperator}`);

        if (isInvpay && data.company.typeDocument === 'cnpj' && cardCnpj) {
          handleSizeDocument(
            cardCnpj[0].size,
            'Cartão CNPJ tem mais de 30MB',
            cardCnpj
          );

          // Para a Invpay, será enviado uma cópia do cartão CNPJ para todos os tipos de documentos.

          formData.append('document[0][type]', 'CNPJ_CARD');
          formData.append('document[0][file]', cardCnpj[0]);

          formData.append('document[1][type]', 'PROOF_OF_ADDRESS');
          formData.append('document[1][file]', cardCnpj[0]);

          formData.append('document[2][type]', 'SOCIAL_CONTRACT');
          formData.append('document[2][file]', cardCnpj[0]);

          formData.append('document[3][type]', 'BILLING_DECLARATION');
          formData.append('document[3][file]', cardCnpj[0]);

          handleSendDocumentToCompany(formData);
        } else if (proofOfAddress && proofOfAccount) {
          handleSizeDocument(
            proofOfAddress[0].size,
            'Comprovante de endereço tem mais de 30MB',
            proofOfAddress
          );
          handleSizeDocument(
            proofOfAccount[0].size,
            'Comprovante de bancário tem mais de 30MB',
            proofOfAccount
          );

          if (
            data.company.typeDocument === 'cnpj' &&
            cardCnpj &&
            socialContract &&
            billingDeclaration
          ) {
            handleSizeDocument(
              cardCnpj[0].size,
              'Cartão CNPJ tem mais de 30MB',
              cardCnpj
            );

            handleSizeDocument(
              socialContract[0].size,
              'Contrato social tem mais de 30MB',
              socialContract
            );
            handleSizeDocument(
              billingDeclaration[0].size,
              'Billing Declaration has more than 30MB',
              billingDeclaration
            );

            formData.append('document[0][type]', 'PROOF_OF_ADDRESS');
            formData.append('document[0][file]', proofOfAddress[0]);

            formData.append('document[1][type]', 'PROOF_OF_ACCOUNT');
            formData.append('document[1][file]', proofOfAccount[0]);

            formData.append('document[2][type]', 'CNPJ_CARD');
            formData.append('document[2][file]', cardCnpj[0]);

            formData.append('document[3][type]', 'SOCIAL_CONTRACT');
            formData.append('document[3][file]', socialContract[0]);

            formData.append('document[4][type]', 'BILLING_DECLARATION');
            formData.append('document[4][file]', billingDeclaration[0]);

            handleSendDocumentToCompany(formData);
          }

          if (data.company.typeDocument === 'cpf') {
            formData.append('document[0][type]', 'PROOF_OF_RESIDENCE');
            formData.append('document[0][file]', proofOfAddress[0]);

            formData.append('document[1][type]', 'PROOF_OF_ACCOUNT');
            formData.append('document[1][file]', proofOfAccount[0]);

            handleSendDocumentToCompany(formData);
          }
        } else {
          return;
        }

        await api.post('invide-user/send/verify-document', {
          idUser: data.iduser,
          idOperator: request.idOperator,
          document: otherInfoData?.document,
          finances: {
            monthlyInvoicing: otherInfoData?.finances.monthlyInvoicing
              ?.replace(/[R$,.]/g, '')
              .trim(),
            shareCapital: otherInfoData?.finances?.shareCapital
              ?.replace(/[R$,.]/g, '')
              .trim(),
            patrimony: otherInfoData?.finances?.patrimony
              ?.replace(/[R$,.]/g, '')
              .trim(),
          },
          otherInfo: otherInfoData?.otherInfo,
        });

        data.verify_documents = 1;
        localStorage.setItem('userData', JSON.stringify(data));

        hideLoader();
        handleChangeTabe('10');
      }
    } catch (err) {
      hideLoader();
      toastError({
        title: 'Ops!!! Algo deu errado.',
        description: 'Não foi possível enviar os arquivos',
      });
    }
  };

  const handleSendDocument = (idOperator: string, type: string, file: File) => {
    return new Promise((resolve, reject) => {
      const formData = new FormData();

      formData.append(
        'systemOrigin',
        `${process?.env.REACT_APP_SYSTEM_ORIGIN}`
      );

      formData.append('idOperator', `${idOperator}`);

      formData.append('document[0][type]', type);
      formData.append('document[0][file]', file);

      apiOnboarding
        .post('api/operator/send-document-by-company', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const handleSendDocumentToCompany = async (formData: any) => {
    try {
      await apiOnboarding.post(
        'api/operator/send-document-by-company',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );
    } catch (error) {
      toastError({
        title: 'Algo deu errado!',
        description: 'Não foi possível enviar o arquivo.',
      });
      throw new Error('Não foi possível enviar o arquivo.');
    }
  };

  const handleSizeDocument = (
    size: number,
    description: string,
    filesList: FileList
  ) => {
    const tamanhoEmMB = size / (1024 * 1024);
    const validTypes = [
      'image/png',
      'image/jpeg',
      'image/jpg',
      'application/pdf',
    ];

    if (!validTypes.includes(filesList[0].type)) {
      toastError({
        title: 'Arquivo do tipo inválido!',
        description: 'O arquivo deve ser dos tipos PDF / PNG / JPG ou JPEG.',
      });
      throw new Error('Arquivo do tipo inválido!');
    }

    if (tamanhoEmMB > 30) {
      toastError({
        title: 'O arquivo deve ter no máximo 30MB',
        description,
      });
      throw new Error('Arquivo deve ser menor que 30MB.');
    }
  };

  useEffect(() => {
    if (data?.company.typeDocument === 'cnpj') {
      if (isInvpay) {
        if (cardCnpj && cardCnpj?.length === 1) {
          setActiveButton((s) => true);
        } else {
          setActiveButton((s) => false);
        }
      }

      if (
        cardCnpj &&
        socialContract &&
        proofOfAddress &&
        proofOfAccount &&
        billingDeclaration
      ) {
        if (
          cardCnpj?.length === 1 &&
          socialContract?.length === 1 &&
          proofOfAddress?.length === 1 &&
          proofOfAccount?.length === 1 &&
          billingDeclaration?.length === 1
        ) {
          setActiveButton((s) => true);
        } else {
          setActiveButton((s) => false);
        }
      }
    }
    if (data?.company.typeDocument === 'cpf') {
      if (proofOfAddress && proofOfAccount) {
        if (proofOfAddress?.length === 1 && proofOfAccount?.length) {
          setActiveButton((s) => true);
        } else {
          setActiveButton((s) => false);
        }
      }
    }
  }, [
    cardCnpj,
    socialContract,
    proofOfAddress,
    proofOfAccount,
    billingDeclaration,
    data,
  ]);

  useEffect(() => {
    setData(JSON.parse(localStorage.getItem('userData') as string));
  }, []);

  return (
    <TabPane tabId="9">
      <Row className="mb-2">
        <Col className="text-center">
          <h2 className="text-primary">Upload de arquivos</h2>
          <p>
            Suba os documentos abaixo em formato legível. (PDF / PNG / JPG /
            JPEG)
          </p>
        </Col>
      </Row>

      <Row className="mb-2">
        <Col lg="12">
          <Row className="d-flex justify-content-center">
            <Col lg="8">
              <Row className="mb-2">
                <Col lg="12">
                  <strong>Obrigatório</strong>
                </Col>
              </Row>

              {data?.company?.typeDocument === 'cnpj' ? (
                <>
                  <Row className="mb-2">
                    <Col>
                      <Label
                        className={`rounded label-file ${
                          cardCnpj?.length ? 'border-success' : 'border'
                        } py-1 px-2`}
                      >
                        {/* // esse input é o de files */}
                        <Input
                          type="file"
                          className="p-2 input-file"
                          onChange={(e) => setCardCnpj(e.target.files)}
                        />
                        <div className="d-flex align-items-center">
                          <FiFileText
                            size={25}
                            className={`${
                              cardCnpj?.length ? 'text-success' : 'text-warning'
                            } mr-2`}
                          />
                          <span>Cartão CNPJ</span>
                        </div>
                        <div className="d-flex align-items-center">
                          {cardCnpj?.length ? (
                            <IoIosCloudDone
                              size={25}
                              className="mr-2 text-success"
                            />
                          ) : (
                            <IoIosCloudUpload
                              size={25}
                              className="mr-2 text-warning"
                            />
                          )}
                        </div>
                      </Label>
                    </Col>
                  </Row>
                  {!isInvpay ? (
                    <>
                      <Row className="mb-2">
                        <Col>
                          <Label
                            className={`rounded label-file ${
                              socialContract?.length
                                ? 'border-success'
                                : 'border'
                            } py-1 px-2`}
                          >
                            <Input
                              type="file"
                              className="p-2 input-file"
                              onChange={(e) =>
                                setSocialContract(e.target.files)
                              }
                            />
                            <div className="d-flex align-items-center">
                              <FiFileText
                                size={25}
                                className={`${
                                  socialContract?.length
                                    ? 'text-success'
                                    : 'text-warning'
                                } mr-2`}
                              />
                              <span>Contrato Social</span>
                            </div>
                            <div className="d-flex align-items-center">
                              {socialContract?.length ? (
                                <IoIosCloudDone
                                  size={25}
                                  className="mr-2 text-success"
                                />
                              ) : (
                                <IoIosCloudUpload
                                  size={25}
                                  className="mr-2 text-warning"
                                />
                              )}
                            </div>
                          </Label>
                        </Col>
                      </Row>
                      <Row className="mb-2">
                        <Col>
                          <Label
                            className={`rounded label-file ${
                              billingDeclaration?.length
                                ? 'border-success'
                                : 'border'
                            } py-1 px-2`}
                          >
                            <Input
                              type="file"
                              className="p-2 input-file"
                              onChange={(e) =>
                                setBillingDeclaration(e.target.files)
                              }
                            />
                            <div className="d-flex align-items-center">
                              <FiFileText
                                size={25}
                                className={`${
                                  billingDeclaration?.length
                                    ? 'text-success'
                                    : 'text-warning'
                                } mr-2`}
                              />
                              <span>Declaração de Faturamento</span>
                            </div>
                            <div className="d-flex align-items-center">
                              {billingDeclaration?.length ? (
                                <IoIosCloudDone
                                  size={25}
                                  className="mr-2 text-success"
                                />
                              ) : (
                                <IoIosCloudUpload
                                  size={25}
                                  className="mr-2 text-warning"
                                />
                              )}
                            </div>
                          </Label>
                        </Col>
                      </Row>
                    </>
                  ) : null}
                </>
              ) : null}

              {!isInvpay || data?.company?.typeDocument === 'cpf' ? (
                <>
                  <Row className="mb-2">
                    <Col>
                      <Label
                        className={`rounded label-file ${
                          proofOfAddress?.length ? 'border-success' : 'border'
                        } py-1 px-2`}
                      >
                        <Input
                          type="file"
                          className="p-2 input-file"
                          onChange={(e) => setProofOfAddress(e.target.files)}
                        />
                        <div className="d-flex align-items-center">
                          <FiFileText
                            size={25}
                            className={`${
                              proofOfAddress?.length
                                ? 'text-success'
                                : 'text-warning'
                            } mr-2`}
                          />
                          <span>Comprovante de Endereço</span>
                        </div>
                        <div className="d-flex align-items-center">
                          {proofOfAddress?.length ? (
                            <IoIosCloudDone
                              size={25}
                              className="mr-2 text-success"
                            />
                          ) : (
                            <IoIosCloudUpload
                              size={25}
                              className="mr-2 text-warning"
                            />
                          )}
                        </div>
                      </Label>
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col>
                      <Label
                        className={`rounded label-file ${
                          proofOfAccount?.length ? 'border-success' : 'border'
                        } py-1 px-2`}
                      >
                        <Input
                          type="file"
                          className="p-2 input-file"
                          onChange={(e) => setProofOfAccount(e.target.files)}
                        />
                        <div className="d-flex align-items-center">
                          <FiFileText
                            size={25}
                            className={`${
                              proofOfAccount?.length
                                ? 'text-success'
                                : 'text-warning'
                            } mr-2`}
                          />
                          <span>Comprovante de Bancário</span>
                        </div>
                        <div className="d-flex align-items-center">
                          {proofOfAccount?.length ? (
                            <IoIosCloudDone
                              size={25}
                              className="mr-2 text-success"
                            />
                          ) : (
                            <IoIosCloudUpload
                              size={25}
                              className="mr-2 text-warning"
                            />
                          )}
                        </div>
                      </Label>
                    </Col>
                  </Row>
                </>
              ) : null}
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col className="d-flex justify-content-between">
          <Button
            size="sm"
            onClick={() => handleChangeTabe('8')}
            color="secondary"
          >
            <RiArrowDropLeftLine size={25} /> Anterior
          </Button>
          <Button
            size="sm"
            onClick={() => handleDocuments()}
            color={`${activeButton ? 'success' : 'secondary'}`}
            style={{ cursor: activeButton ? 'pointer' : 'not-allowed' }}
            disabled={!activeButton}
          >
            Finalizar <RiArrowDropRightLine size={25} />
          </Button>
        </Col>
      </Row>
    </TabPane>
  );
};

export default SendProof;
